export default __webpack_public_path__ + "static/media/illustration-algocare-w.dee3d489.png";